"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M13.7947 14.2138c-.168-.496-.252-1.232-.252-2.208 0-.976.084-1.712.252-2.208.168-.496.48-.744.936-.744.448 0 .76.248.936.744.176.496.264 1.232.264 2.208 0 .984-.088 1.72-.264 2.208-.176.488-.488.732-.936.732-.456 0-.768-.244-.936-.732z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 3H2v18h20V3zm-4.5693 11.3698c.2-.656.3-1.444.3-2.364 0-1.392-.244-2.476-.732-3.252-.488-.776-1.244-1.164-2.268-1.164-.728 0-1.312.176-1.752.528-.44.352-.756.856-.948 1.512-.192.656-.288 1.448-.288 2.376 0 1.376.24 2.456.72 3.24.48.776 1.236 1.164 2.268 1.164.736 0 1.32-.176 1.752-.528.44-.352.756-.856.948-1.512zm-9.2232-3.036v4.956h1.812v-8.568h-1.488l-2.76 2.196.876 1.092.984-.792c.112-.096.232-.204.36-.324.136-.128.224-.216.264-.264-.008.256-.02.552-.036.888-.008.336-.012.608-.012.816z"
  })];
};

exports.default = _default;